var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsBackupRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "183.19468688964844 -803.6900634765625 591.2653198242188 619.6900634765625",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.25-448q-12.87 0-22.33-9.67-9.46-9.68-9.46-22.54 0-12.87 9.68-22.33 9.67-9.46 22.53-9.46 12.87 0 22.33 9.67 9.46 9.68 9.46 22.54 0 12.87-9.67 22.33-9.68 9.46-22.54 9.46m.21 264q-123.08 0-210.04-86.46T183.23-480h30.46q4.31 109.23 80.35 186.62Q370.08-216 478.46-216q110.32 0 187.16-76.78t76.84-187T665.62-667t-187.16-77q-52.08 0-99.19 19.73-47.12 19.73-86.89 54.73h96.24v32H222.46v-166.15h32v131.54q43.3-49.02 101.19-76.43Q413.54-776 478.46-776q61.6 0 115.4 23.14 53.79 23.14 94.06 63.4 40.26 40.27 63.4 94.05t23.14 115.37q0 61.58-23.14 115.4-23.14 53.83-63.4 94.1-40.27 40.26-94.06 63.4Q540.06-184 478.46-184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBackupRestore);
export default __webpack_public_path__ + "static/media/settings_backup_restore.c470f9ba18f6ed0e5a26d1825b20a1a5.svg";
export { ForwardRef as ReactComponent };